export const eventClasses = Object.freeze({
  BASIC: 'basic',
  LESSON: 'lesson',
  TIMESLOT: 'timeslot',
});
